import { Link, useLocation } from 'react-router-dom';

/**
 * 404 page. Replaces the previous silent <Navigate to="/"> for
 * unknown routes — silent redirects make broken share-links
 * hard to debug and rob the visitor of the chance to fix the
 * URL themselves.
 *
 * The path is shown so the user can see what they typed; the
 * suggestions cover the four most common destinations.
 */
export default function NotFoundPage() {
  const location = useLocation();
  return (
    <div className="mx-auto max-w-lg space-y-4 py-8 text-center">
      <p className="text-6xl">🤔</p>
      <h1 className="font-display text-2xl font-semibold uppercase tracking-wide text-ec-face">Page not found</h1>
      <p className="font-serif text-sm text-ec-bone">
        We couldn't find{' '}
        <code className="rounded bg-ec-panel px-1.5 py-0.5 font-mono text-ec-bone">
          {location.pathname}
        </code>
        .
      </p>
      <ul className="space-y-1 text-sm text-ec-bone">
        <li>
          ·{' '}
          <Link to="/" className="text-ec-brass hover:underline">
            Browse games
          </Link>
        </li>
        <li>
          ·{' '}
          <Link to="/lobbies" className="text-ec-brass hover:underline">
            Open lobbies
          </Link>
          <span className="text-ec-bone-dim"> — find a game in progress</span>
        </li>
        <li>
          ·{' '}
          <Link to="/me/matches" className="text-ec-brass hover:underline">
            Your matches
          </Link>
        </li>
        <li>
          ·{' '}
          <Link to="/leaderboard" className="text-ec-brass hover:underline">
            Leaderboard
          </Link>
        </li>
      </ul>
      <p className="font-serif text-xs text-ec-bone-dim">
        If you got here from a link in this app, please file an issue.
      </p>
    </div>
  );
}
